<script setup>
/**
 * Useful to display a button that submits a form.
 * Has a build in form which is sent to the given url using the given method and includes the given data.
 *
 * See button components for more information on the button itself.
 */
import Button from '@/Components/Buttons/Button.vue';

import {mapErrors} from '@/utilities';
import {useForm} from '@inertiajs/vue3';
import {useSlots} from "vue";

const props = defineProps({
  url: String,
  method: {
    type: String,
    default: 'get',
  },
  data: {
    type: Object,
    default: () => ({}),
  },
  label: String,
  disabled: Boolean,
  danger: Boolean,
  removeWidth: Boolean,
  classes: String,
  small: Boolean,
});

const emits = defineEmits(['onSuccess']);

const form = useForm({});
const slots = useSlots();

const submitForm = () => {
  form.transform((data) => ({
    ...data,
    ...props.data,
  })).submit(props.method, props.url, {
    preserveState: true,
    preserveScroll: true,
    onError: (errors) => (form.errors = mapErrors(errors)),
    onSuccess: () => (emits('onSuccess')),
  });
};
</script>
<template>
    <Button
        :label="label"
        :form="form"
        :danger="danger || method === 'delete'"
        :disabled="disabled"
        :remove-width="removeWidth"
        :classes="classes"
        :small="small"
        @click="submitForm"
    >
        <div
            v-if="!slots.default"
            class="text-center leading-tight"
        >
            {{ label }}
        </div>
        <slot />
    </Button>
</template>
